@switch (state()) {
  @case ('ready') {
    @if (rows().length === 0) {
      <av-empty-state
        icon="request_quote"
        [title]="'backoffice.dashboard.revenue.empty.title' | translate"
        [message]="'backoffice.dashboard.revenue.empty.message' | translate"
      ></av-empty-state>
    } @else {
      <div class="table-scroll">
        <table class="av-table w-100">
          <thead>
            <tr>
              <th scope="col">{{ 'backoffice.dashboard.revenue.columns.plan' | translate }}</th>
              <th scope="col">{{ 'backoffice.dashboard.revenue.columns.market' | translate }}</th>
              <th scope="col" class="text-end">
                {{ 'backoffice.dashboard.revenue.columns.subscriptions' | translate }}
              </th>
              <th scope="col" class="text-end">
                {{ 'backoffice.dashboard.revenue.columns.monthly' | translate }}
              </th>
              <th scope="col">{{ 'backoffice.dashboard.revenue.columns.coverage' | translate }}</th>
            </tr>
          </thead>

          <tbody>
            @for (row of rows(); track row.planId) {
              <tr>
                <td class="cell-strong">{{ row.planName }}</td>
                <td class="cell-muted">{{ row.marketLabel }}</td>
                <td class="text-end">{{ row.subscriberCount }}</td>
                <td class="text-end">
                  {{ row.monthlyRevenue | number: '1.2-2' }} {{ currencyOf(row) }}
                </td>
                <td>
                  @if (row.isPartial) {
                    <av-status-chip
                      [label]="
                        'backoffice.dashboard.revenue.coverage.partial'
                          | translate: { scanned: row.scannedCount, total: row.subscriberCount }
                      "
                      tone="warning"
                    ></av-status-chip>
                  } @else {
                    <av-status-chip
                      [label]="'backoffice.dashboard.revenue.coverage.complete' | translate"
                      tone="positive"
                    ></av-status-chip>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  }
  @case ('error') {
    <av-empty-state
      icon="error_outline"
      [title]="'backoffice.dashboard.revenue.error.title' | translate"
      [message]="'backoffice.dashboard.revenue.error.message' | translate"
    ></av-empty-state>
  }
  @default {
    <av-empty-state
      icon="hourglass_empty"
      [title]="'backoffice.dashboard.revenue.loading.title' | translate"
      [message]="'backoffice.dashboard.revenue.loading.message' | translate"
    ></av-empty-state>
  }
}
